import { faTimes } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import Linkify from 'linkify-react';
import Link from 'next/link';
import propTypes from 'prop-types';
import { useContext, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import {
  PROBLEM_AT,
  CLOSE,
  HELP_CENTRE,
  PROBLEM_NON_WAREHOUSE_INFO_ONE,
  PROBLEM_WAREHOUSE_INFO_ONE,
  PROBLEM_WAREHOUSE_INFO_TWO,
  NEED_RETURN_ORDER,
  WHEN_DELIVERY,
  WHEN_DELIVERY_DESCRIPTION,
  RETURN_ITEM,
  RESALEABLE_CONDITION,
  PLEASE_NOTE,
  REFUND_NOT_POSSIBLE,
} from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { showNeedReturns } from '../../helpers/vouchers';
import ThemeContext from '../../providers/ThemeProvider';
import Icon from '../Icon';
import CollapsableSection from '../deal/shared-components/CollapsableSection';
import ReturnsPortal from '../myaccount/ReturnsPortal';
import VoucherReturnsForm from './VoucherReturnsForm';
import { DEFAULT_EVENT_KEY, HELP_EVENT_KEY } from './constants';

const VoucherAccordionHelp = ({ voucher, setToggle }) => {
  const [collapsed, setCollapsed] = useState(true);
  const theme = useContext(ThemeContext);
  const toggleAccodionSection = () => {
    setCollapsed((state) => !state);
    collapsed && trackEvent('myaccount-returnitem');
  };

  return (
    <>
      <Accordion.Collapse eventKey={HELP_EVENT_KEY}>
        <div className="help-wrapper">
          <div className="help-header">
            <button
              aria-label={CLOSE}
              className="help-close"
              onClick={() => setToggle(DEFAULT_EVENT_KEY)}
              type="button"
            >
              <Icon faIcon={faTimes} />
            </button>
          </div>
          <div className="help-body">
            <div className="section">
              <h4 className="title">{NEED_RETURN_ORDER}</h4>
              {voucher.warehouseDeal && (
                <p>
                  {PROBLEM_WAREHOUSE_INFO_ONE}
                  <Link href="https://help.wowcher.co.uk">
                    <a className="primary" href="https://help.wowcher.co.uk">
                      {HELP_CENTRE}
                    </a>
                  </Link>
                  {PROBLEM_WAREHOUSE_INFO_TWO}
                </p>
              )}
              {!voucher.warehouseDeal && (
                <>
                  <p>{PROBLEM_NON_WAREHOUSE_INFO_ONE}</p>
                  <p className="business">
                    {`${voucher.businessName} ${PROBLEM_AT} `}
                    <Linkify>{voucher.customerServiceInfo}</Linkify>
                  </p>
                </>
              )}
            </div>
            <div
              className={classNames({
                section: !voucher.alternativeReturnsProcess,
              })}
            >
              <h4 className="title">{WHEN_DELIVERY}</h4>
              <p>{WHEN_DELIVERY_DESCRIPTION[process.env.NEXT_PUBLIC_BRAND]}</p>
            </div>
            {!voucher.alternativeReturnsProcess &&
              !voucher?.returnsPortal?.returnable &&
              showNeedReturns(voucher) && (
                <CollapsableSection
                  collapsed={collapsed}
                  onToggle={toggleAccodionSection}
                  title={RETURN_ITEM}
                >
                  <p>{RESALEABLE_CONDITION}</p>
                  <p>
                    <span className="bold">{PLEASE_NOTE}: </span>
                    {REFUND_NOT_POSSIBLE}
                  </p>
                  <VoucherReturnsForm isOpen={!collapsed} voucher={voucher} />
                </CollapsableSection>
              )}
            {voucher?.returnsPortal?.returnable && showNeedReturns(voucher) && (
              <CollapsableSection
                collapsed={collapsed}
                onToggle={toggleAccodionSection}
                title={RETURN_ITEM}
              >
                <ReturnsPortal voucher={voucher} />
              </CollapsableSection>
            )}
          </div>
        </div>
      </Accordion.Collapse>
      <style jsx>{`
        .help-wrapper {
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
          margin-bottom: 14px;
        }
        .help-header {
          display: flex;
          flex-direction: row-reverse;
          padding: 10px;
        }
        .help-body {
          padding: 20px;
          background: ${theme.colors.white};
          border: 1px solid ${theme.colors.lightboxgrayborders};
          border-radius: 5px;
          margin-bottom: 14px;
        }
        .help-close {
          background-color: transparent;
          border: none;
        }
        .title {
          color: ${theme.colors.primary};
          margin-bottom: 5px;
          font-size: 20px;
          font-weight: 500;
        }
        .section {
          margin-bottom: 20px;
        }
        .business {
          font-size: 1.2em;
        }
        .business :global(a),
        .primary {
          color: ${theme.colors.primary};
        }
        .bold {
          font-weight: bold;
          font-size: 0.9em;
        }
        .help-body :global(.section-title__content) {
          color: ${theme.colors.primary};
          font-size: 20px;
          font-weight: 500;
        }
        .help-body p:last-child {
          margin-bottom: 0;
        }
        .help-body :global(.section-title) {
          ${collapsed ? 'margin-bottom:  0' : ''};
        }
      `}</style>
    </>
  );
};

VoucherAccordionHelp.propTypes = {
  setToggle: propTypes.func.isRequired,
  voucher: propTypes.object,
};

export default VoucherAccordionHelp;
